<script>
  import { router } from '@inertiajs/svelte'
  import Button from '@/components/ui/Button.svelte'
  import Card from '@/components/ui/Card.svelte'
  import Input from '@/components/ui/Input.svelte'
  
  let { flash = {} } = $props()
  
  let email = $state('')
  let isSubmitting = $state(false)
  let submitted = $state(false)
  
  function handleSubmit(e) {
    e.preventDefault()
    isSubmitting = true
    
    router.post('/password/forgot', { email }, {
      onSuccess: () => {
        submitted = true
      },
      onFinish: () => {
        isSubmitting = false
      }
    })
  }
</script>

<div class="min-h-screen bg-gray-50 dark:bg-dark-primary flex items-center justify-center px-4 py-10">
  <div class="max-w-md w-full">
    <!-- Logo -->
    <div class="text-center mb-8">
      <h1 class="text-h1 text-content mb-2">AX Hub</h1>
    </div>
    
    <!-- Card -->
    <Card padding="lg" bordered>
      {#if flash.notice}
        <div class="mb-6 p-4 bg-success-light border border-success/30 rounded-xl text-success text-body2">
          {flash.notice}
        </div>
      {/if}
      
      {#if flash.alert}
        <div class="mb-6 p-4 bg-error-light border border-error/30 rounded-xl text-error text-body2">
          {flash.alert}
        </div>
      {/if}
      
      {#if submitted || flash.notice}
        <!-- Success State -->
        <div class="text-center">
          <div class="flex justify-center mb-6">
            <div class="w-16 h-16 bg-success-light rounded-full flex items-center justify-center">
              <svg class="w-8 h-8 text-success" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <h2 class="text-h2 text-content mb-2">이메일을 확인해주세요</h2>
          <p class="text-body2 text-content-secondary mb-6">
            입력하신 이메일로 비밀번호 재설정 링크를 발송했습니다.
            메일함을 확인해주세요.
          </p>
          <a href="/login" class="text-primary hover:text-primary-light text-body2 transition-colors">
            ← 로그인으로 돌아가기
          </a>
        </div>
      {:else}
        <!-- Form State -->
        <div class="text-center mb-6">
          <div class="flex justify-center mb-4">
            <div class="w-16 h-16 bg-surface-tertiary rounded-full flex items-center justify-center">
              <svg class="w-8 h-8 text-content-tertiary" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
              </svg>
            </div>
          </div>
          <h2 class="text-h2 text-content mb-2">비밀번호 찾기</h2>
          <p class="text-body2 text-content-secondary">
            가입하신 이메일 주소를 입력해주세요.
            비밀번호 재설정 링크를 보내드립니다.
          </p>
        </div>
        
        <form onsubmit={handleSubmit} class="space-y-5">
          <Input type="email" label="이메일" placeholder="you@email.com" bind:value={email} required />
          
          <Button type="submit" fullWidth loading={isSubmitting} loadingLabel="전송 중..." disabled={!email}>
            재설정 링크 보내기
          </Button>
        </form>
        
        <p class="mt-6 text-center">
          <a href="/login" class="text-content-tertiary text-body2 hover:text-gray-900 dark:hover:text-dark-text-high transition-colors">
            ← 로그인으로 돌아가기
          </a>
        </p>
      {/if}
    </Card>
  </div>
</div>
